import React from "react";
import styled from "styled-components";
import img1 from "../assets/icons/onlinrefill.png";
import img2 from "../assets/icons/custompackaging.png";
import img3 from "../assets/icons/assistedliving.png";
import img4 from "../assets/images/MedicationSync/OIP-removebg-preview.png";
import img5 from "../assets/icons/immunization.png";
import img6 from "../assets/icons/transferrx.png";
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from "react";


const Overlay = () => {
  useEffect(() => {
    Aos.init({duration: 2000});
  }, []);
  return (
    <OverlayMainContainer >
      <OverlayContainer data-aos="zoom-in">
        <OverlayTop>
          <OverlayImg src={img1} />
        </OverlayTop>
        <OverlayBottom className="overlay">
          <OverlayBody> Online Refill</OverlayBody>
        </OverlayBottom>
      </OverlayContainer>
      <OverlayContainer data-aos="zoom-in">
        <OverlayTop>
          <OverlayImg src={img2} />
        </OverlayTop>
        <OverlayBottom className="overlay">
          <OverlayBody> Custom Packaging</OverlayBody>
        </OverlayBottom>
      </OverlayContainer>
      <OverlayContainer data-aos="zoom-in">
        <OverlayTop>
          <OverlayImg src={img3} />
        </OverlayTop>
        <OverlayBottom className="overlay">
          <OverlayBody> Assisted Living</OverlayBody>
        </OverlayBottom>
      </OverlayContainer>
      <OverlayContainer data-aos="zoom-in">
        <OverlayTop>
          <OverlayImg src={img5} />
        </OverlayTop>
        <OverlayBottom className="overlay">
          <OverlayBody> Immunizations</OverlayBody>
        </OverlayBottom>
      </OverlayContainer>
      <OverlayContainer data-aos="zoom-in">
        <OverlayTop>
          <OverlayImg src={img6} />
        </OverlayTop>
        <OverlayBottom className="overlay">
          <OverlayBody> Transfer RX</OverlayBody>
        </OverlayBottom>
      </OverlayContainer>
      <OverlayContainer data-aos="zoom-in">
        <OverlayTop>
          <OverlayImg src={img4} />
        </OverlayTop>
        <OverlayBottom className="overlay">
          <OverlayBody> Med Sync</OverlayBody>
        </OverlayBottom>
      </OverlayContainer>
      <OverlayContainer data-aos="zoom-in">
        <OverlayTop>
          <OverlayImg src={img4} />
        </OverlayTop>
        <OverlayBottom className="overlay">
          <OverlayBody> Medical Adherence</OverlayBody>
        </OverlayBottom>
      </OverlayContainer>
    </OverlayMainContainer>
  );
};

export default Overlay;

const OverlayMainContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2rem;
`;

const OverlayBody = styled.p`
  font-size: 2rem;
  color: white;
`;

const OverlayImg = styled.img`
  width: 70%;
  padding-top: 20rem;
`;

const OverlayTop = styled.div`
  width: 100%;
  height: 0;
  /* top: 0; */
  /* left: 0; */
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OverlayBottom = styled.div`
  position: absolute;
  opacity: 0;
  transition: all 0.6s ease;
  width: 100%;
  height: 100%;
  background: var(--color-blue);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scale(0);
  border-radius: 50%;
`;

const OverlayContainer = styled.div`
  position: relative;
  width: 350px;
  height: 330px;
  display: inline-block;
  margin-bottom: 5rem;
  border-radius: 50%;
  background: #e0e0e0;
  box-shadow: 5px 5px 19px #5a5a5a, -5px -5px 19px #ffffff;
  overflow: hidden;
  

  &:hover .overlay {
    opacity: 0.8;
    transform: scale(1);
    border-radius: 0%;
  }
`;
